import { CfTurnstileChallenge } from './challenge';

import { Sentry } from '../../sentry';
import { env } from '../../config';

let instance: InstanceType<typeof CfTurnstileChallenge> | undefined;

export function getCfTurnstileChallenge() {
  if (instance) {
    return instance;
  }

  if (env.CF_TURNSTILE_SITEKEY) {
    instance = new CfTurnstileChallenge({
      siteKey: env.CF_TURNSTILE_SITEKEY,
      onChallengeError(error: Error, params) {
        Sentry.captureMessage(`[CF Turnstile] ${error.message}`, {
          // @ts-expect-error HookParams object is serializable for extra
          extra: params,
          level: 'error',
        });
      },
      onWafForbiddenError(params) {
        Sentry.captureMessage(
          '[CF Turnstile] cf waf forbidden error encountered',
          { level: params.isCleared ? 'error' : 'warning' },
        );
      },
      onInteractiveChallengePrompted() {
        Sentry.captureMessage('[CF Turnstile] interactive challenge prompted', {
          level: 'warning',
        });
      },
    });

    return instance;
  }
}
